module.exports = {"371521001":"博济桥街道","371521002":"侨润街道","371521003":"狮子楼街道","371521101":"阎楼镇","371521103":"阿城镇","371521104":"七级镇","371521105":"安乐镇","371521106":"定水镇","371521107":"石佛镇","371521108":"李台镇","371521109":"寿张镇","371521111":"十五里园镇","371521112":"张秋镇","371521113":"郭店屯镇","371521114":"西湖镇","371521115":"高庙王镇","371521116":"金斗营镇","371521203":"大布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371521.json
// module id = 1486
// module chunks = 0